<!--
@Author: MIYONGLE
@Desc: form弹窗
@Date: 2021-08-02 14时
-->

<template>
  <div id='dialogBox'>
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="isDisplay"
      width="1200px"
      height="528px"
      custom-class='page-main-box'
      @close='closeOpera'
      >
        <div class="pc-form-main">
          <!-- <span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span> -->
          <slot></slot>
          <div class="pc-form">
            <el-form class="pc-form-con" :rules="formRules" ref="paramAppointment" :model="paramAppointment">
              <el-form-item class="pc-form-line" prop='name'>
                <p><img src="../../static/pc/ic_home_name.png" alt="灵活用工"/></p>
                <el-input type="text" v-model="paramAppointment.name" placeholder="请输入您的姓名" class="pc-form-item"></el-input>
              </el-form-item>
              <el-form-item class="pc-form-line" prop='phone'>
                <p><img src="../../static/pc/ic_home_iphone.png" alt="灵活用工"/></p>
                <el-input type="text" v-model="paramAppointment.phone" placeholder="请输入您的电话号码" class="pc-form-item"></el-input>
              </el-form-item>
              <el-form-item class="pc-form-line" prop='companyName'>
                <p><img src="../../static/pc/ic_home_company.png" alt="灵活用工"/></p>
                <el-input type="text" v-model="paramAppointment.companyName" placeholder="请输入您的公司全称" class="pc-form-item"></el-input>
              </el-form-item>
              <el-form-item class="pc-form-line" prop="provinceCity">
              <p>
                <img
                  src="../../static/pc/icon_input_position.png"
                  alt="灵活用工"
                />
              </p>
              <el-cascader
                v-model="paramAppointment.provinceCity"
                :options="optionsProvinceOrCity"
                placeholder="请选择公司所在位置"
                @change="handleChange"
                @expand-change="expandChange"
                ref="cascader"
              ></el-cascader>
            </el-form-item>
              <span class='pc-form-btn' @click="xhrImmediatelySub()">立即预约</span>
            </el-form>
          </div>
        </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import {MessageBox} from 'element-ui';
import {postMakeAppoint,postFindProvinceOrCity} from "../service/apis";
import {HTTP_CODE} from "../service/axios_constants";
import { checkNull } from "../filters/filters";

export default {
  name: "pcFormDialog",

  props: {

    source: {
      type: String,
      defalut: ''
    } // 子组件传过来的

  },

  data() {
    return {
      //校验
      formRules:{
        name:[{required: true, message: '姓名不能为空', trigger: ['blur', 'change']},],
        phone:[{required: true, message: '电话不能为空', trigger: 'blur'},],
        companyName:[{required: true, message: '公司不能为空', trigger: 'blur'},],
        provinceCity:[{required: true, message: '公司所在城市不能为空', trigger: 'blur'},]
      },

      optionsProvinceOrCity: [],//公司所在城市区选择
      optionsProvinceOrCityTemp: [],

      paramAppointment:{
        name:'',
        phone:'',
        companyName:'',
        source:'',
        bdVid:'',
        province:'',
        city:'',
        provinceCity:'',
      },

      clickDisabled: false,     // 禁止重复点击预约
      isDisplay: false
    }
  },

  components: {

  },

  mounted () {
    
    eventBus.$on("pcOperaDiaLog", (msg) => {
      this.isDisplay = msg;
    });
  },

  created() {
    this.paramAppointment.bdVid = this.$route.query.bd_vid;
    this.xhrPostFindProvinceOrCity();
  },

  methods: {
    //xhr--立即预约
    xhrImmediatelySub(){
      if(this.clickDisabled){
        return;
      }
      this.$refs['paramAppointment'].validate((valid) => {
        if (valid) {
          this.clickDisabled = true;
          this.paramAppointment.source = this.source;
          postMakeAppoint(this.paramAppointment).then(res=>{
            this.clickDisabled = false;
            if (res.statusCode === HTTP_CODE.suc) {
              this.isDisplay = false;
              this.$refs['paramAppointment'].resetFields();
              this.paramAppointment.provinceCity = ''
              
              MessageBox('预约成功！', '提示', {
                confirmButtonText: '确定',
                showCancelButton:false,
                confirmButtonClass: 'btnFullColor'
              })
            }
          })
        }
      })
    },

    handleChange(value) {;
      // console.log(this.$refs['cascader'].getCheckedNodes()[0].pathLabels,'yuyu');
      this.paramAppointment.province = this.$refs['cascader'].getCheckedNodes()[0].pathLabels[0]
      this.paramAppointment.city = this.$refs['cascader'].getCheckedNodes()[0].pathLabels[1]
    },

    expandChange(value) {
      this.xhrPostFindProvinceOrCity(value[0]);
    },

    // xhr----查询省市接口
    xhrPostFindProvinceOrCity(value) {
      let paramQuery = {
        provinceId: value,
      };
      postFindProvinceOrCity(paramQuery).then((res) => {
        if (res.statusCode === HTTP_CODE.suc) {
          if(checkNull(paramQuery.provinceId)){
            this.optionsProvinceOrCityTemp = res.data;
            for (let type of this.optionsProvinceOrCityTemp) {
              type.value = type.code;
              type.label = type.name;
              type.children = [];
            }
          }else{
            for(let item of this.optionsProvinceOrCityTemp){
              if(item.code == value){
                item.children = res.data
                for(let val of item.children){
                  val.value = val.code;
                  val.label = val.name;
                }
              }
            }
          }
          this.optionsProvinceOrCity = JSON.parse(JSON.stringify(this.optionsProvinceOrCityTemp))
        }
      });
    },

    // 清空表单
    closeOpera(){
      this.$refs['paramAppointment'].resetFields();
    }

  }
}
</script>

<style>
  .pc-form-con .el-form-item__content .el-input{
    height:60px;
    line-height:60px;
    border:1px solid #F4F4F4;
    border-radius:8px;
    width: 520px;
  }
  .pc-form-con .el-input__inner{
    padding-left:50px;
    border:none;
    box-sizing:border-box;
    height:initial;
    line-height:initial;
  }
  .pc-form-con .el-form-item{
    margin-bottom: 20px;
  }
  .pc-form-item input::-webkit-input-placeholder{
    /* WebKit browsers */
    color: #CFCFCF;
  }
  .pc-form-item input:-moz-placeholder{
    /* Mozilla Firefox 4 to 18 */
    color: #CFCFCF;
  }
  .pc-form-item input::-moz-placeholder{
    /* Mozilla Firefox 19+ */
    color: #CFCFCF;
  }
  .pc-form-item input:-ms-input-placeholder{
    /* Internet Explorer 10+ */
    color: #CFCFCF;
  }

  #dialogBox .el-dialog__body{
    height: 528px;
    padding: 0;
    max-height: none;
  } 

  #dialogBox .el-dialog__wrapper .el-dialog .el-dialog__header{
    background-color: #fff;
    height: 64px;
  }

  #dialogBox .el-dialog__headerbtn{
    font-size: 26px;
  }

  #dialogBox .el-dialog__headerbtn .el-dialog__close{
    color: #d2d1d1;
  }

  #dialogBox .el-dialog__wrapper .el-dialog{
    /* height: 528px; */
  }

  #dialogBox .el-dialog__wrapper .el-dialog__body .el-input, #dialogBox .el-dialog__wrapper .el-dialog__body .el-select{
    width: 520px;
  }
  #dialogBox .el-input__suffix{
    display: none;
  }

  /* //标题 */
  #dialogBox .pc-form-main .pc-form-text{
    font-size: 32px;
    font-weight: 600;
    display: block;
    text-align: center;
    margin-top:-20px;
  }
  #dialogBox .el-dialog__body{
    background: #fff;
  }

</style>

<style lang="scss" scoped>

//弹窗开始
.page-main-box{
  .pc-form-main{
    width:100%;
    background:#fff;
    // box-shadow: 0px 20px 60px 0px rgba(0, 0, 0, 0.1);
    //标题
    
    .pc-form-text{
      font-size: 32px;
      font-weight: 600;
      // margin-top: 60px;
      display: block;
      margin-bottom: 55px;
      text-align: center;
    }

    //表单
    .pc-form{
      width: 520px;
      margin: auto;
      .pc-form-img{
        padding-top:60px;
        padding-bottom: 10px;
      }
      .pc-form-con{
        width:520px;
        margin:0 auto;
        margin-top:16px;
        .pc-form-line{
          position:relative;
          p{
            width:20px;
            height:20px;
            position:absolute;
            z-index:999;
            left:20px;
            top:15px;
            img{
              width:100%;
            }
          }
        }
        .pc-form-btn{
          background: #1985FF;
          border-radius:30px;
          font-size: 18px;
          color:#FFFFFF;
          width:200px;
          height: 48px;
          margin: 0 auto;
          margin-top:48px;
          margin-bottom: 52px;
          display: block;
          line-height: 48px;
          text-align: center;
        }
      }
    }
  }
}
  
</style>


// WEBPACK FOOTER //
// src/components/pcFormDialog.vue